@import 'styles/variables';

.olTypesDropdown {
  display: flex;
}
